import { render, staticRenderFns } from "./TopupDeposit.vue?vue&type=template&id=ecf87f42"
import script from "./TopupDeposit.vue?vue&type=script&lang=js"
export * from "./TopupDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports